export default "<div class=\"noSearchResults\">\n\n    <js-templateNonce></js-templateNonce>\n    {{- msg}}</div>";